import { render } from "./ExpansionPanel.vue?vue&type=template&id=3c2e40dc&ts=true"
import script from "./ExpansionPanel.vue?vue&type=script&lang=ts"
export * from "./ExpansionPanel.vue?vue&type=script&lang=ts"

import "./ExpansionPanel.vue?vue&type=style&index=0&id=3c2e40dc&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.21_vue@3.4.21_typescript@5.4.5__webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__